import { useDirectionStore } from '@/store/directionStore'

// Content offset + header presence per direction; MainLayout consumes this
export function useShellLayout() {
  const d = useDirectionStore(s => s.direction)
  if (d === 'command') return { ml: 'lg:ml-16', opsStrip: true, canvas: false }
  if (d === 'saas') return { ml: 'lg:ml-60', opsStrip: false, canvas: false }
  if (d === 'expressive') return { ml: 'lg:ml-[17.5rem]', opsStrip: false, canvas: true }
  return { ml: null, opsStrip: false, canvas: false }   // current: MainLayout keeps its original classes verbatim
}
